<template>
  <div v-if="isDisplay">
    <h2>360度パノラマビュー</h2>
    <div class="select-wrapper">
      <kcs-select
        v-model="dataId"
        :options="labels"
        name="label"
        class="streetview_select"
      />
    </div>
    <div class="map-wrapper">
      <div v-html="dataHtml" class="map-embed-box" />
    </div>
  </div>
</template>

<script>
import KcsSelect from '@/components/atoms/kcs-select.vue'
export default {
  components: {
    KcsSelect
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataId: '',
      dataHtml: ''
    }
  },
  computed: {
    labels() {
      return this.detail.streetviews.map((streetview) => {
        return { name: streetview.label, value: streetview.id.toString() }
      })
    },
    isDisplay() {
      if (
        Object.keys(this.detail.streetviews).length >= 1 &&
        this.detail.streetviews
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    // ラベルが変更されたら、iframeを変更する
    dataId(value) {
      const streetview = this.detail.streetviews.find(
        (streetview) => streetview.id === Number(value)
      )
      this.dataHtml = streetview.html
    }
  },
  mounted() {
    if (this.isDisplay) {
      this.dataId = this.detail.streetviews[0].id.toString()
    }
  }
}
</script>
